
import { useIdentity } from "@equipmentshare/auth0-react";
import { Option } from "@morphism/fp";
import React from "react";
import { App } from "~/App";
import { Company } from "~/Company";
import { Login } from "~/Login";

export function IdentityProvider() {
    const identity = useIdentity();
  
    return pipe(
      Company.fromIdentity(identity),
      Option.map((company) => <App company={company} identity={identity} />),
      Option.getOrElseW(() => {
        !window.location.href.includes("localhost") &&
          // eslint-disable-next-line functional/immutable-data
          void (window.location.href = Login.hrefWithRedirect());
  
        return null;
      })
    );
  }
